import AdvancedNavbarContent from "./AdvancedNavbarContent";

const AdvancedNavbar = (props) => {
  const depthLevel = 0;
  return <AdvancedNavbarContent depthLevel={depthLevel} {...props} />;
};

export default AdvancedNavbar;
